module.exports = __webpack_public_path__ + "img/waves.52a19cc0.svg";